import { render, staticRenderFns } from "./PersonalPanel.vue?vue&type=template&id=187015cd&scoped=true&"
import script from "./PersonalPanel.vue?vue&type=script&lang=js&"
export * from "./PersonalPanel.vue?vue&type=script&lang=js&"
import style0 from "./PersonalPanel.vue?vue&type=style&index=0&id=187015cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187015cd",
  null
  
)

export default component.exports